import React from 'react'

class VerificationSaveComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        <button
          style={styles.button}
          type={this.props.type}>
          <span style={styles.label}>{this.props.label}</span>
        </button>
      </div>
    )
  }
}

const styles = {
  link: {
    textDecoration: 'none'
  },
  buttonContent: {
    marginTop: '8px',
    float: 'right',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    marginTop: '4px',
    width: '191px',
    height: '36px',
    borderWidth: '0px',
    borderRadius: '10px',
    backgroundColor: '#2C343A',
    outline: 'none'
  },
  label: {
    textAlign: 'center',
    color: '#A6B9C8',
    fontSize: '12px',
    fontWeight: 500
  }
}

export default VerificationSaveComponent
